"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteUser = void 0;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const user_api_1 = require("../../../../utils/api/user/user.api");
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const constante_1 = require("../../../../utils/constante");
const UseCrudAdmin = (handleClose, item) => {
    const [code, setCode] = (0, react_1.useState)("SN");
    const [phone, setPhone] = (0, react_1.useState)();
    const validationSchema = yup.object().shape({
        fullname: yup.string().required("Le nom est requis.").label("Nom"),
        email: yup.string().required("Le type est requis.").label("Email"),
        status: yup.mixed().required("Le type d'utilisateur est requis.").label("Type d'utilisateur"),
        phone: yup.string().required("Le téléphone est requis.").label("Téléphone"),
    });
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, watch, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const [addOrUpdateAdmin, { isLoading, isSuccess, error, isError }] = (0, user_api_1.useAddOrEditAdminMutation)();
    const handleChangeStatus = (e) => {
        const status = e.target.value;
        setValue("status", status);
        if (status === "admin") {
            constante_1.Authorisations.forEach((auth) => {
                setValue(`permissions.${auth.field}`, true);
            });
        }
        else if (status === "collaborator") {
            constante_1.Authorisations.forEach((auth) => {
                if (auth.field === "dashboard" || auth.field === "sos-remorquages" || auth.field === "notifications") {
                    setValue(`permissions.${auth.field}`, true);
                }
                else {
                    setValue(`permissions.${auth.field}`, false);
                }
            });
        }
        else if (status === "management") {
            constante_1.Authorisations.forEach((auth) => {
                if (auth.field === "dashboard" || auth.field === "transactions" || auth.field === "utilisateurs") {
                    setValue(`permissions.${auth.field}`, true);
                }
                else {
                    setValue(`permissions.${auth.field}`, false);
                }
            });
        }
    };
    const handleCheckboxChange = (e) => {
        const { name } = e.target;
        constante_1.Authorisations.forEach((auth) => {
            setValue(`permissions.${auth.field}`, auth.field === name);
        });
    };
    const handleChangePhone = (item, country) => {
        var _a;
        setCode(((_a = country === null || country === void 0 ? void 0 : country.countryCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || "SN");
        setPhone(item);
        if (parseInt(item) !== parseInt(country === null || country === void 0 ? void 0 : country.dialCode)) {
            setValue(`phone`, "+" + item);
        }
        else {
            setValue(`phone`, "");
        }
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Admin ${item ? "modifié" : "ajouté"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!item) {
                    reset();
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => {
        addOrUpdateAdmin({ id: item === null || item === void 0 ? void 0 : item.user_id, data: data });
    }, [addOrUpdateAdmin, item === null || item === void 0 ? void 0 : item.user_id]);
    (0, react_1.useEffect)(() => {
        if (item) {
            console.log("item", item);
            setValue("fullname", item === null || item === void 0 ? void 0 : item.fullname);
            setValue("email", item === null || item === void 0 ? void 0 : item.email);
            setValue("phone", item === null || item === void 0 ? void 0 : item.phone);
            if ((item === null || item === void 0 ? void 0 : item.status) === "superadmin" ||
                (item === null || item === void 0 ? void 0 : item.status) === "admin" ||
                (item === null || item === void 0 ? void 0 : item.status) === "collaborator" ||
                (item === null || item === void 0 ? void 0 : item.status) === "management" ||
                (item === null || item === void 0 ? void 0 : item.status) === "staff") {
                setValue("status", item === null || item === void 0 ? void 0 : item.status);
            }
            else {
                setValue("status", undefined);
            }
            if (item === null || item === void 0 ? void 0 : item.phone) {
                setPhone(item === null || item === void 0 ? void 0 : item.phone);
            }
            constante_1.Authorisations.forEach((auth) => {
                var _a;
                setValue(`permissions.${auth.field}`, ((_a = item === null || item === void 0 ? void 0 : item.permissions) === null || _a === void 0 ? void 0 : _a[auth.field]) || false);
            });
        }
    }, [item]);
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        isSuccess,
        watch,
        handleClose,
        handleChangeStatus,
        handleCheckboxChange,
        handleChangePhone,
        phone,
        setPhone
    };
};
exports.default = UseCrudAdmin;
const useDeleteUser = (userId) => {
    const [deleteData] = (0, user_api_1.useDeleteUserMutation)();
    const onDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer cet utilisateur ?`,
            text: "Cette action est irréversible.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(userId);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: "Utilisateur supprimé avec succès!",
                    iconColor: theme_1.Color.success,
                    showConfirmButton: false,
                    timer: 1200,
                });
            }
        });
    });
    return onDelete;
};
exports.useDeleteUser = useDeleteUser;
